import _regenerator from "/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted } from "vue";
import { useStore } from "vuex";
import { is_ios_h5 } from "@/utils/devices";
import { getFingerprint } from "@/utils/make";
var __default__ = {
  name: 'App'
};
export default /*@__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    var store = useStore();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            window.ulGetParamsCallBack = function (key, value) {
              if (is_ios_h5()) {
                if (key == 'is_auto_login') {
                  store.commit('setIsAutoLogin', Boolean(value));
                } else if (key == 'small_id') {
                  store.commit('setSmallId', value);
                } else if (key == 'pay_order_number') {
                  store.commit('setPayOrderNumber', value);
                } else {
                  store.commit('setItemState', {
                    key: key,
                    value: value
                  });
                }
              }
            };
            _context.n = 1;
            return getFingerprint();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
});